exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.movie-wrap[data-v-5e618551] {\r\n     position: relative;\r\n     padding-bottom: 56.25%; /*アスペクト比 16:9の場合の縦幅*/\r\n     height: 0;\r\n     overflow: hidden;\r\n     /* width: 80vw; */\r\n     margin: 5vw;\n}\n.movie-wrap iframe[data-v-5e618551] {\r\n     position: absolute;\r\n     top: 0;\r\n     left: 0;\r\n     width: 100%;\r\n     height: 100%;\n}\r\n", ""]);

// exports
